import React, {PureComponent} from 'react';
import FontAwesome from 'react-fontawesome';
import Table from '../../../components/Table';
import {Col, Button, Row, Card, CardBody,Badge,ButtonGroup} from 'reactstrap';
import * as http from '../../../modules/http';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {
    tasks_open_update_form,
    tasks_delete
} from '../../../redux/actions/TasksActions';
import EditTasksForm from './EditTaskForm'
import Modal from '../../../components/Modal';
import { withStyles } from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import IconButton from '@material-ui/core/IconButton';
import PropTypes from 'prop-types';
import * as TextManager from "../../../modules/languages/TextManager";


const actionsStyles = theme => ({
    root: {
        flexShrink: 0,
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing.unit * 2.5,
    },
});

class TablePaginationActions extends React.Component {
    handleFirstPageButtonClick = event => {
        this.props.onChangePage(event, 0);
    };

    handleBackButtonClick = event => {
        this.props.onChangePage(event, this.props.page - 1);
    };

    handleNextButtonClick = event => {
        this.props.onChangePage(event, this.props.page + 1);
    };

    handleLastPageButtonClick = event => {
        this.props.onChangePage(
            event,
            Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1),
        );
    };

    render() {
        const { classes, count, page, rowsPerPage, theme } = this.props;

        return (
            <div className={classes.root}>
                <IconButton
                    onClick={this.handleFirstPageButtonClick}
                    disabled={page === 0}
                    aria-label="First Page"
                >
                    {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
                </IconButton>
                <IconButton
                    onClick={this.handleBackButtonClick}
                    disabled={page === 0}
                    aria-label="Previous Page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                </IconButton>
                <IconButton
                    onClick={this.handleNextButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Next Page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                </IconButton>
                <IconButton
                    onClick={this.handleLastPageButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Last Page"
                >
                    {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
                </IconButton>
            </div>
        );
    }
}

TablePaginationActions.propTypes = {
    classes: PropTypes.object.isRequired,
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    theme: PropTypes.object.isRequired,
};

const TablePaginationActionsWrapped = withStyles(actionsStyles, { withTheme: true })(
    TablePaginationActions,
);


const CustomPagination = withStyles(theme => ({
    root: {
        float: 'left'
    },
    '@media screen and (max-width: 480px)': {
        root: {
            //backgroundColor: theme.palette.common.black,
            marginLeft: '-50px'
        }
    }

}))(TablePagination);


class TasksTable extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            windowType: 0,
            selectedID: '0',
            saving: false,
            error: false,
            page: 0,
            rowsPerPage: 20
        };
    }

    handleChangePage = (event, page) => {
        this.setState({page});
    };

    handleChangeRowsPerPage = event => {
        this.setState({rowsPerPage: event.target.value});
    };

    addTask = () => {

        var task = {id: 0, date: '', provider: 0, task: '', name: '', storeId: 0, managerId: 0, comment: '', status: 1};
        this.props.dispatch(tasks_open_update_form(task));
        this.setState({
            selectedID: 0, windowType: 2, error: false,
        });
    };

    editTask = (task) => {
        if (task.id === this.state.selectedID && this.state.windowType === 2) {
            this.setState({selectedID: 0, windowType: 0, generatedTemplate: ''});
        }
        else {
            this.props.dispatch(tasks_open_update_form(task));
            this.setState({
                selectedID: task.id, windowType: 2, error: false,
            });
        }
    };

    deleteTask = (task) => {
        //abc
        http.postToServer(
            'tasks/delete',
            task,
            (response) => {
                this.props.dispatch(tasks_delete(task.id));

            },
            (response) => {
                console.log('error delete creative');
            }
        );

    };

    getStatus = (status) => {
        if (status === 1)
            return TextManager.getCurrentTextResource().Text.new;
        else if(status === 2)
            return TextManager.getCurrentTextResource().Text.active;
        else if(status === 3)
            return TextManager.getCurrentTextResource().Text.inactive;
    };

    getStatusColor = (status) => {
        if (status === 1)
            return "warning";
        else if(status === 2)
            return "success";
        else if(status === 3)
            return "danger";
        else
            return "primary";
    };

    getRow(task, index, isDelete) {
        let providerName = '';
        let provider = this.props.utilsData.data.providers.find(a => a.value === task.provider);

        if(provider !== undefined) {
            providerName = provider.label;
        }
        else {
            console.log(task.provider);
        }

        return (

            <React.Fragment key={task.id}>

                <tr key={task.id} onClick={() => this.editTask(task)}>

                    <td>
                        <Badge color={this.getStatusColor(task.status)}>{this.getStatus(task.status)}</Badge>
                    </td>
                    {/*<td>{task.comment}</td>
                    <td>{this.props.utilsData.data.managers.find(a => a.id === task.managerId).name}</td>
                    <td>{this.props.utilsData.data.stores.find(a => a.value === task.storeId).label}</td>*/}
                    <td>{task.name}</td>
                    <td>{task.task}</td>
                    <td>{providerName}</td>
                    <td>{task.date}</td>
                    {
                        this.props.userData && (this.props.userData.data.isAdmin || this.props.userData.data.id === 39) &&
                        <td>
                            <Modal color='danger' title='Are you sure!'
                                   approve={() => this.deleteTask(task)}
                                   message={'Delete Task ' + task.task + '?'}>


                                <Button color='danger' size='sm'
                                        style={{padding: "0px 15px"}}>
                                    <FontAwesome name='times'/>
                                </Button>

                            </Modal>
                        </td>

                    }

                </tr>

                {task.id === this.state.selectedID &&
                <tr key={task.id + 2000}>
                    <td colSpan="12">
                        <EditTasksForm onClose={() => this.editTask(task)} />
                    </td>
                </tr>
                }
            </React.Fragment>
        );
    }

    render() {

        const {rowsPerPage, page} = this.state;

        //Build the And add the selected row
        let rows = [];

        if(this.props.utilsData && this.props.utilsData.data && this.props.utilsData.data.providers) {
            rows = this.props.data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((task, index) =>
                this.getRow(task, index)
            );
        }

        let isAdding = this.state.windowType === 2 && this.state.selectedID === 0;

        return (
            <Col md={12} xl={12} lg={12} xs={12}>
                <Card>
                    <CardBody>
                        {isAdding &&
                        <EditTasksForm
                            onClose={() => this.setState({selectedID: 0, windowType: 0, generatedTemplate: ''})}/>
                        }

                        {!isAdding &&
                        <span>
                            <Table responsive className='table-hover table--bordered'>
                                <thead>
                                <tr>
                                    <th>סטאטוס</th>
                                    {/*<th>הערות</th>*
                                    <th>נציג נטפל</th>
                                    <th>שם חנות</th>*/}
                                    <th>שם לקוח</th>
                                    <th>המשימה</th>
                                    <th>חברה סלולרית</th>
                                    <th>תאריך</th>
                                    {
                                        //this.props.userData && this.props.userData.data.isAdmin &&
                                        <th>


                                            <Button color='primary' size='sm'
                                                    style={{padding: "0px 15px", margin: "0px"}}
                                                    onClick={() => this.addTask()}>
                                                <FontAwesome name='plus-square' style={{marginLeft: "5px"}}/>
                                            </Button>

                                        </th>

                                    }
                                    {
                                        this.props.userData && this.props.userData.data.isManager &&
                                        <th></th>

                                    }
                                </tr>
                                </thead>
                                <tbody>
                                {rows}
                                </tbody>
                            </Table>
                            <CustomPagination
                                labelRowsPerPage='' //{TextManager.getCurrentTextResource().Utils.rowsPerPage}
                                rowsPerPageOptions={[5, 10, 20]}
                                component="div"
                                count={this.props.data.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                backIconButtonProps={{
                                    'aria-label': 'Previous Page',
                                }}
                                nextIconButtonProps={{
                                    'aria-label': 'Next Page',
                                }}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActionsWrapped}
                            />
                        </span>
                        }
                    </CardBody>
                </Card>
            </Col>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        status: state.tasks.status,
        userData: state.userData,
        utilsData: state.utilsData,
    };
};

export default withRouter(connect(mapStateToProps)(TasksTable))